import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import RedeemCouponForm from '../forms/RedeemCouponForm';
import Dialog from './Dialog';
import Modal from './Modal';

const propTypes = {
    prize: AppPropTypes.prize,
    closesOnSuccess: PropTypes.bool,
    onClose: PropTypes.func,
    onComplete: PropTypes.func,
};

const defaultProps = {
    prize: null,
    closesOnSuccess: false,
    onClose: null,
    onComplete: null,
};

const RedeemCouponModal = ({ prize, closesOnSuccess, onClose, onComplete }) => {
    const [opened, setOpened] = useState(true);
    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    const onSuccess = useCallback(
        (user) => {
            if (closesOnSuccess) {
                onRequestClose();
            }

            if (onComplete !== null) {
                onComplete(user);
            }
        },
        [closesOnSuccess, onRequestClose, onComplete],
    );

    return (
        <Modal opened={opened} withSafe onClickSafe={onRequestClose} onClosed={onClose}>
            <Dialog>
                <RedeemCouponForm
                    prize={prize}
                    onSuccess={onSuccess}
                    onClickClose={onRequestClose}
                />
            </Dialog>
        </Modal>
    );
};

RedeemCouponModal.propTypes = propTypes;
RedeemCouponModal.defaultProps = defaultProps;

export default RedeemCouponModal;
